(function () {
  'use strict';

  if (window.NBBScentEngine && window.NBBScentEngine.version === '3.0.3') return;

  var DIMENSIONS = [
    'sweetness',
    'freshness',
    'warmth',
    'gourmand',
    'floral',
    'clean',
    'woody'
  ];

  var NOTE_WEIGHT = 1;
  var ACCORD_WEIGHT = 0.35;

  var noteMap = {
    vanilla: { families:['gourmand','amber'], traits:['sweet','creamy','warm','cozy'], sweetness:5, freshness:1, warmth:5, gourmand:5, floral:0, clean:1, woody:0 },
    amber: { families:['amber','resinous'], traits:['warm','smooth','sensual','cozy'], sweetness:3, freshness:0, warmth:5, gourmand:2, floral:0, clean:1, woody:1 },
    musk: { families:['musk','skin scent'], traits:['soft','clean','smooth','intimate'], sweetness:1, freshness:2, warmth:2, gourmand:0, floral:0, clean:5, woody:0 },
    sandalwood: { families:['woody','creamy'], traits:['smooth','soft','creamy','elegant'], sweetness:1, freshness:1, warmth:4, gourmand:1, floral:0, clean:2, woody:5 },
    caramel: { families:['gourmand'], traits:['sweet','rich','sticky','cozy'], sweetness:5, freshness:0, warmth:5, gourmand:5, floral:0, clean:0, woody:0 },
    pear: { families:['fruity','fresh'], traits:['juicy','bright','playful','feminine'], sweetness:3, freshness:4, warmth:1, gourmand:1, floral:0, clean:2, woody:0 },
    bergamot: { families:['citrus','fresh'], traits:['sparkling','bright','clean','uplifting'], sweetness:1, freshness:5, warmth:0, gourmand:0, floral:0, clean:4, woody:0 },
    rose: { families:['floral'], traits:['romantic','soft','classic','feminine'], sweetness:2, freshness:2, warmth:2, gourmand:0, floral:5, clean:1, woody:0 },
    jasmine: { families:['white floral'], traits:['floral','lush','feminine','bold'], sweetness:2, freshness:2, warmth:3, gourmand:0, floral:5, clean:1, woody:0 },
    coconut: { families:['gourmand','tropical'], traits:['creamy','sunny','sweet','smooth'], sweetness:4, freshness:2, warmth:4, gourmand:4, floral:0, clean:1, woody:0 },
    tonka: { families:['gourmand','amber'], traits:['warm','sweet','powdery','cozy'], sweetness:4, freshness:0, warmth:5, gourmand:4, floral:0, clean:0, woody:1 },
    benzoin: { families:['amber','resinous'], traits:['warm','vanillic','smooth','cozy'], sweetness:4, freshness:0, warmth:5, gourmand:4, floral:0, clean:0, woody:1 },
    patchouli: { families:['woody','earthy'], traits:['deep','earthy','rich','grounded'], sweetness:1, freshness:1, warmth:4, gourmand:0, floral:0, clean:0, woody:4 },
    citrus: { families:['citrus','fresh'], traits:['bright','sparkling','clean','fresh'], sweetness:1, freshness:5, warmth:0, gourmand:0, floral:0, clean:4, woody:0 },
    cherry: { families:['fruity','gourmand'], traits:['sweet','juicy','playful','bold'], sweetness:5, freshness:2, warmth:3, gourmand:4, floral:0, clean:0, woody:0 },
    marshmallow: { families:['gourmand'], traits:['sweet','fluffy','soft','cozy'], sweetness:5, freshness:0, warmth:4, gourmand:5, floral:0, clean:1, woody:0 },
    oud: { families:['woody','resinous'], traits:['deep','bold','rich','smoky'], sweetness:1, freshness:0, warmth:5, gourmand:0, floral:0, clean:0, woody:5 },
    saffron: { families:['spicy','amber'], traits:['warm','luxurious','leathery','smooth'], sweetness:1, freshness:1, warmth:5, gourmand:0, floral:0, clean:1, woody:2 },
    tobacco: { families:['warm spicy','gourmand'], traits:['rich','warm','smooth','cozy'], sweetness:3, freshness:0, warmth:5, gourmand:3, floral:0, clean:0, woody:2 },
    leather: { families:['leather','woody'], traits:['bold','smooth','rich','edgy'], sweetness:1, freshness:0, warmth:4, gourmand:0, floral:0, clean:0, woody:3 },
    iris: { families:['powdery','floral'], traits:['powdery','elegant','soft','smooth'], sweetness:1, freshness:2, warmth:2, gourmand:0, floral:4, clean:3, woody:1 },
    orris: { families:['powdery','floral'], traits:['powdery','elegant','soft','smooth'], sweetness:1, freshness:2, warmth:2, gourmand:0, floral:4, clean:3, woody:1 },
    violet: { families:['powdery','floral'], traits:['soft','powdery','delicate','feminine'], sweetness:2, freshness:2, warmth:1, gourmand:0, floral:4, clean:3, woody:0 },
    peach: { families:['fruity'], traits:['juicy','sweet','soft','playful'], sweetness:4, freshness:3, warmth:2, gourmand:2, floral:0, clean:1, woody:0 },
    almond: { families:['gourmand','nutty'], traits:['creamy','sweet','soft','cozy'], sweetness:4, freshness:0, warmth:4, gourmand:5, floral:0, clean:0, woody:1 },
    pistachio: { families:['gourmand','nutty'], traits:['creamy','sweet','playful','cozy'], sweetness:4, freshness:1, warmth:4, gourmand:5, floral:0, clean:0, woody:1 },
    coffee: { families:['gourmand'], traits:['rich','warm','dark','cozy'], sweetness:3, freshness:0, warmth:5, gourmand:5, floral:0, clean:0, woody:1 },
    chocolate: { families:['gourmand'], traits:['sweet','rich','warm','decadent'], sweetness:5, freshness:0, warmth:5, gourmand:5, floral:0, clean:0, woody:0 },
    honey: { families:['gourmand','amber'], traits:['sweet','golden','warm','rich'], sweetness:5, freshness:0, warmth:5, gourmand:4, floral:1, clean:0, woody:0 },
    milk: { families:['lactonic','gourmand'], traits:['creamy','soft','comforting','smooth'], sweetness:3, freshness:0, warmth:3, gourmand:5, floral:0, clean:1, woody:0 },
    lactonic: { families:['lactonic','gourmand'], traits:['creamy','soft','comforting','smooth'], sweetness:3, freshness:0, warmth:3, gourmand:5, floral:0, clean:1, woody:0 },
    cedar: { families:['woody'], traits:['dry','clean','smooth','grounded'], sweetness:0, freshness:2, warmth:3, gourmand:0, floral:0, clean:3, woody:5 },
    vetiver: { families:['woody','green'], traits:['dry','earthy','clean','fresh'], sweetness:0, freshness:3, warmth:2, gourmand:0, floral:0, clean:3, woody:5 },
    lavender: { families:['aromatic','fresh'], traits:['calming','clean','soft','herbal'], sweetness:1, freshness:4, warmth:1, gourmand:0, floral:2, clean:5, woody:0 },
    tea: { families:['fresh','aromatic'], traits:['clean','soft','airy','calming'], sweetness:1, freshness:4, warmth:1, gourmand:0, floral:1, clean:5, woody:0 },
    matcha: { families:['green','tea'], traits:['soft','green','creamy','calming'], sweetness:1, freshness:4, warmth:1, gourmand:1, floral:0, clean:4, woody:0 },
    salt: { families:['marine','fresh'], traits:['clean','airy','fresh','skin-like'], sweetness:0, freshness:5, warmth:1, gourmand:0, floral:0, clean:5, woody:0 },
    incense: { families:['resinous','smoky'], traits:['warm','smoky','deep','mysterious'], sweetness:1, freshness:0, warmth:5, gourmand:0, floral:0, clean:0, woody:3 },
    cashmere: { families:['woody','musk'], traits:['soft','smooth','cozy','clean'], sweetness:1, freshness:1, warmth:3, gourmand:0, floral:0, clean:4, woody:3 },
    suede: { families:['leather','musk'], traits:['soft','smooth','warm','intimate'], sweetness:1, freshness:0, warmth:3, gourmand:0, floral:0, clean:1, woody:2 },

    /* v2.1 high-value catalog notes */
    cacao: { families:['gourmand'], traits:['dark','rich','chocolate'], sweetness:4, freshness:0, warmth:4, gourmand:5, floral:0, clean:0, woody:0 },
    cardamom: { families:['spicy','aromatic'], traits:['warm','fresh','spicy'], sweetness:1, freshness:2, warmth:4, gourmand:1, floral:0, clean:1, woody:1 },
    cinnamon: { families:['spicy','gourmand'], traits:['warm','sweet','spicy'], sweetness:3, freshness:0, warmth:5, gourmand:3, floral:0, clean:0, woody:1 },
    fig: { families:['fruity','green'], traits:['creamy','green','soft'], sweetness:3, freshness:3, warmth:2, gourmand:2, floral:0, clean:2, woody:1 },
    plum: { families:['fruity'], traits:['juicy','dark','sweet'], sweetness:4, freshness:2, warmth:3, gourmand:2, floral:0, clean:0, woody:0 },
    rice: { families:['gourmand','soft'], traits:['soft','creamy','starchy'], sweetness:2, freshness:1, warmth:2, gourmand:4, floral:0, clean:2, woody:0 },
    tuberose: { families:['white floral'], traits:['lush','creamy','bold'], sweetness:2, freshness:1, warmth:3, gourmand:0, floral:5, clean:0, woody:0 },
    ambroxan: { families:['amber','musk'], traits:['clean','smooth','diffusive','warm'], sweetness:1, freshness:2, warmth:3, gourmand:0, floral:0, clean:4, woody:2 },
    neroli: { families:['citrus','white floral','fresh'], traits:['fresh','clean','floral','bright'], sweetness:1, freshness:5, warmth:1, gourmand:0, floral:4, clean:5, woody:0 },
    'orange blossom': { families:['white floral'], traits:['floral','soft','sweet','fresh'], sweetness:2, freshness:3, warmth:2, gourmand:0, floral:5, clean:3, woody:0 },
    heliotrope: { families:['powdery','floral'], traits:['powdery','soft','almond-like','vanillic'], sweetness:3, freshness:1, warmth:2, gourmand:2, floral:3, clean:2, woody:0 },
    apricot: { families:['fruity'], traits:['juicy','soft','sweet'], sweetness:4, freshness:3, warmth:2, gourmand:2, floral:0, clean:1, woody:0 },
    chestnut: { families:['nutty','gourmand'], traits:['nutty','warm','roasted','soft'], sweetness:2, freshness:0, warmth:4, gourmand:4, floral:0, clean:0, woody:1 }
  };

  var aliases = {
    'vanilla bean':'vanilla',
    'madagascar vanilla':'vanilla',
    'bourbon vanilla':'vanilla',
    'white amber':'amber',
    'amberwood':'amber',
    'ambrox':'ambroxan',
    'white musk':'musk',
    'skin musk':'musk',
    'cashmere musk':'musk',
    'musky':'musk',
    'cashmere wood':'cashmere',
    'cashmere woods':'cashmere',
    'cashmeran':'cashmere',
    'creamy woods':'sandalwood',
    'woods':'cedar',
    'wood':'cedar',
    'coconut milk':'coconut',
    'lemon':'citrus',
    'orange':'citrus',
    'mandarin':'citrus',
    'grapefruit':'citrus',
    'lime':'citrus',
    'black cherry':'cherry',
    'dark cherry':'cherry',
    'marshmallow fluff':'marshmallow',
    'praline':'caramel',
    'brown sugar':'caramel',
    'sugar':'caramel',
    'coumarin':'tonka',
    'labdanum':'amber',
    'olibanum':'incense',
    'smoke':'incense',
    'smoky notes':'incense',
    'sea salt':'salt',
    'marine notes':'salt',
    'aquatic notes':'salt',
    'green tea':'tea',
    'black tea':'tea',

    /* v2.1 additional normalization */
    'cocoa':'cacao',
    'cocoa bean':'cacao',
    'cacao bean':'cacao',
    'cardamon':'cardamom',
    'fig fruit':'fig',
    'rice accord':'rice',
    'rice note':'rice',
    'violet leaf':'violet',
    'warm spicy':'spicy',
    'fresh spicy':'spicy',
    'soft spicy':'spicy',
    'white floral':'floral',
    'yellow floral':'floral'
  };

  var accordMap = {
    sweet: { families:['sweet'], traits:['sweet'], sweetness:5, freshness:0, warmth:3, gourmand:3, floral:0, clean:0, woody:0 },
    gourmand: { families:['gourmand'], traits:['edible','comforting'], sweetness:4, freshness:0, warmth:4, gourmand:5, floral:0, clean:0, woody:0 },
    powdery: { families:['powdery'], traits:['powdery','soft'], sweetness:2, freshness:1, warmth:2, gourmand:0, floral:2, clean:3, woody:0 },
    woody: { families:['woody'], traits:['woody','grounded'], sweetness:0, freshness:1, warmth:3, gourmand:0, floral:0, clean:1, woody:5 },
    floral: { families:['floral'], traits:['floral'], sweetness:2, freshness:2, warmth:2, gourmand:0, floral:5, clean:2, woody:0 },
    fruity: { families:['fruity'], traits:['juicy','bright'], sweetness:4, freshness:3, warmth:1, gourmand:2, floral:0, clean:1, woody:0 },
    fresh: { families:['fresh'], traits:['fresh','bright'], sweetness:0, freshness:5, warmth:0, gourmand:0, floral:1, clean:4, woody:0 },
    aromatic: { families:['aromatic'], traits:['aromatic','fresh'], sweetness:0, freshness:4, warmth:1, gourmand:0, floral:1, clean:4, woody:1 },
    green: { families:['green'], traits:['green','fresh'], sweetness:0, freshness:5, warmth:0, gourmand:0, floral:1, clean:4, woody:1 },
    earthy: { families:['earthy'], traits:['earthy','grounded'], sweetness:0, freshness:1, warmth:3, gourmand:0, floral:0, clean:0, woody:4 },
    balsamic: { families:['amber','resinous'], traits:['warm','smooth','resinous'], sweetness:2, freshness:0, warmth:5, gourmand:1, floral:0, clean:0, woody:2 },
    resinous: { families:['resinous'], traits:['warm','deep','resinous'], sweetness:2, freshness:0, warmth:5, gourmand:1, floral:0, clean:0, woody:3 },
    spicy: { families:['spicy'], traits:['spicy','warm'], sweetness:1, freshness:1, warmth:4, gourmand:1, floral:0, clean:0, woody:2 },
    creamy: { families:['creamy'], traits:['creamy','smooth','soft'], sweetness:3, freshness:0, warmth:3, gourmand:4, floral:0, clean:2, woody:1 },
    nutty: { families:['nutty','gourmand'], traits:['nutty','creamy'], sweetness:3, freshness:0, warmth:3, gourmand:4, floral:0, clean:0, woody:1 },
    tropical: { families:['tropical','fruity'], traits:['juicy','sunny'], sweetness:4, freshness:3, warmth:3, gourmand:2, floral:1, clean:1, woody:0 },
    smoky: { families:['smoky'], traits:['smoky','deep'], sweetness:0, freshness:0, warmth:5, gourmand:0, floral:0, clean:0, woody:4 },
    aquatic: { families:['aquatic','fresh'], traits:['watery','fresh','airy'], sweetness:0, freshness:5, warmth:0, gourmand:0, floral:0, clean:5, woody:0 },
    marine: { families:['marine','fresh'], traits:['marine','fresh','airy'], sweetness:0, freshness:5, warmth:0, gourmand:0, floral:0, clean:5, woody:0 },
    ozonic: { families:['ozonic','fresh'], traits:['airy','fresh','clean'], sweetness:0, freshness:5, warmth:0, gourmand:0, floral:0, clean:5, woody:0 },
    salty: { families:['marine'], traits:['salty','airy','skin-like'], sweetness:0, freshness:4, warmth:1, gourmand:0, floral:0, clean:4, woody:0 },
    soapy: { families:['clean'], traits:['soapy','clean'], sweetness:0, freshness:4, warmth:0, gourmand:0, floral:1, clean:5, woody:0 },
    soft: { families:['soft'], traits:['soft','smooth'], sweetness:1, freshness:2, warmth:2, gourmand:0, floral:1, clean:4, woody:1 },
    aldehydic: { families:['aldehydic'], traits:['airy','sparkling','clean'], sweetness:0, freshness:4, warmth:0, gourmand:0, floral:2, clean:5, woody:0 },
    animalic: { families:['animalic'], traits:['animalic','deep'], sweetness:0, freshness:0, warmth:4, gourmand:0, floral:0, clean:0, woody:2 },
    metallic: { families:['metallic'], traits:['metallic','cool'], sweetness:0, freshness:4, warmth:0, gourmand:0, floral:0, clean:3, woody:1 },
    mineral: { families:['mineral'], traits:['mineral','dry','clean'], sweetness:0, freshness:4, warmth:1, gourmand:0, floral:0, clean:4, woody:2 },
    mossy: { families:['mossy','woody'], traits:['mossy','earthy'], sweetness:0, freshness:2, warmth:2, gourmand:0, floral:0, clean:1, woody:4 },
    solar: { families:['solar'], traits:['warm','sunny'], sweetness:2, freshness:2, warmth:4, gourmand:1, floral:2, clean:1, woody:0 },
    clean: { families:['clean'], traits:['clean','fresh','polished'], sweetness:0, freshness:4, warmth:0, gourmand:0, floral:0, clean:5, woody:0 },
    warm: { families:['warm'], traits:['warm','soft'], sweetness:1, freshness:0, warmth:5, gourmand:1, floral:0, clean:0, woody:1 },

    /* v2.1 catalog coverage */
    berry: { families:['fruity'], traits:['juicy','sweet','bright'], sweetness:4, freshness:3, warmth:1, gourmand:2, floral:0, clean:1, woody:0 },
    boozy: { families:['boozy','amber'], traits:['warm','rich','spirited'], sweetness:2, freshness:0, warmth:5, gourmand:2, floral:0, clean:0, woody:2 },
    'cotton candy': { families:['gourmand'], traits:['sweet','airy','sugary'], sweetness:5, freshness:1, warmth:2, gourmand:5, floral:0, clean:0, woody:0 },
    herbal: { families:['aromatic','green'], traits:['herbal','fresh','green'], sweetness:0, freshness:4, warmth:1, gourmand:0, floral:1, clean:3, woody:1 },
    licorice: { families:['aromatic','gourmand'], traits:['dark','sweet','anise-like'], sweetness:3, freshness:1, warmth:3, gourmand:3, floral:0, clean:0, woody:1 },
    anise: { families:['aromatic','spicy'], traits:['anise-like','fresh','spicy'], sweetness:2, freshness:3, warmth:2, gourmand:2, floral:0, clean:1, woody:0 },
    champagne: { families:['fresh','fruity'], traits:['sparkling','bright','effervescent'], sweetness:2, freshness:5, warmth:0, gourmand:1, floral:0, clean:4, woody:0 },
    rum: { families:['boozy','gourmand'], traits:['warm','dark','sweet'], sweetness:3, freshness:0, warmth:5, gourmand:3, floral:0, clean:0, woody:2 },
    whiskey: { families:['boozy','woody'], traits:['warm','dark','oaky'], sweetness:1, freshness:0, warmth:5, gourmand:1, floral:0, clean:0, woody:4 },
    savory: { families:['savory'], traits:['savory','dry'], sweetness:0, freshness:1, warmth:2, gourmand:1, floral:0, clean:0, woody:1 },
    sour: { families:['fruity','fresh'], traits:['tart','bright'], sweetness:1, freshness:5, warmth:0, gourmand:1, floral:0, clean:2, woody:0 }
  };

  var contextTags = {
    casual:true,
    everyday:true,
    evening:true,
    formal:true,
    'date night':true,
    'going out':true,
    work:true,
    'special occasion':true,
    spring:true,
    summer:true,
    fall:true,
    winter:true,
    indie:true
  };

  var dimensionMeta = {
    sweetness:{ label:'Sweet' },
    freshness:{ label:'Fresh' },
    warmth:{ label:'Warm' },
    gourmand:{ label:'Gourmand' },
    floral:{ label:'Floral' },
    clean:{ label:'Clean' },
    woody:{ label:'Woody' }
  };

  function normalizeTag(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[-_]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function canonicalTag(value) {
    var normalized = normalizeTag(value);
    return aliases[normalized] || normalized;
  }

  function titleCase(value) {
    return String(value || '')
      .split(' ')
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  function addScore(bucket, key, amount) {
    if (!key) return;
    bucket[key] = (bucket[key] || 0) + amount;
  }

  function topKeys(bucket, limit) {
    return Object.keys(bucket)
      .sort(function (a, b) {
        if (bucket[b] === bucket[a]) return a.localeCompare(b);
        return bucket[b] - bucket[a];
      })
      .slice(0, limit);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function emptyScores() {
    var result = {};
    DIMENSIONS.forEach(function (dimension) {
      result[dimension] = 0;
    });
    return result;
  }

  function levelData(score) {
    score = Number(score) || 0;
    if (score >= 4.25) return { label:'Signature', key:'signature' };
    if (score >= 3.5) return { label:'Strong', key:'strong' };
    if (score >= 2.5) return { label:'Moderate', key:'moderate' };
    if (score >= 1.5) return { label:'Soft', key:'soft' };
    return { label:'Low', key:'low' };
  }

  function profileData(avg) {
    if (avg.gourmand >= 3.6 && avg.warmth >= 3.4) {
      return { key:'warm_gourmand', name:'Warm Creamy Gourmand', short:'Your profile leans cozy, softly sweet, warm, and comfort-driven.' };
    }
    if (avg.clean >= 3.6 && avg.freshness >= 3) {
      return { key:'clean_fresh', name:'Clean Fresh Softie', short:'Your profile leans soft, clean, airy, fresh, and easy to wear.' };
    }
    if (avg.woody >= 3.3 && avg.warmth >= 3) {
      return { key:'woody_amber', name:'Woody Amber Lover', short:'Your profile leans smooth, warm, woody, polished, and ambered.' };
    }
    if (avg.sweetness >= 3.7 && avg.freshness >= 2.2) {
      return { key:'fruity_sweet', name:'Fruity Sweet', short:'Your profile leans juicy, playful, sweet, bright, and easy to love.' };
    }
    if (avg.floral >= 3.4 && avg.clean >= 2.4) {
      return { key:'soft_floral', name:'Soft Clean Floral', short:'Your profile leans delicate, graceful, smooth, and softly floral.' };
    }
    if (avg.warmth >= 3.8 && avg.woody >= 2.6 && avg.clean <= 2) {
      return { key:'dark_rich', name:'Dark Rich', short:'Your profile leans bold, warm, deep, resinous, and statement-making.' };
    }
    if (avg.clean >= 3.2 && avg.woody >= 1.4 && avg.gourmand <= 2.2) {
      return { key:'skin_musk', name:'Skin Musk', short:'Your profile leans soft, intimate, smooth, clean, and skin-like.' };
    }
    if (avg.sweetness >= 3.8 && avg.gourmand >= 3) {
      return { key:'warm_gourmand', name:'Sweet Gourmand Lover', short:'Your profile leans sweet, cozy, creamy, and gourmand-forward.' };
    }
    if (avg.freshness >= 3.7) {
      return { key:'clean_fresh', name:'Bright Fresh Explorer', short:'Your profile leans bright, sparkling, clean, and refreshing.' };
    }
    if (avg.floral >= 3.4) {
      return { key:'soft_floral', name:'Romantic Floral Lover', short:'Your profile leans floral, soft, feminine, and polished.' };
    }
    if (avg.warmth >= 3.5) {
      return { key:'woody_amber', name:'Warm Amber Lover', short:'Your profile leans warm, smooth, ambered, and cozy.' };
    }
    return { key:'default', name:'Balanced Scent Explorer', short:'Your profile blends several scent directions, which gives you more room to explore.' };
  }

  function getSignal(rawTag) {
    var normalized = normalizeTag(rawTag);

    if (!normalized) {
      return { type:'unknown', key:'', weight:0, scent:null };
    }

    if (contextTags[normalized]) {
      return { type:'context', key:normalized, weight:0, scent:null };
    }

    var canonical = aliases[normalized] || normalized;

    if (noteMap[canonical]) {
      return { type:'note', key:canonical, raw:normalized, weight:NOTE_WEIGHT, scent:noteMap[canonical] };
    }

    if (accordMap[canonical]) {
      return { type:'accord', key:canonical, raw:normalized, weight:ACCORD_WEIGHT, scent:accordMap[canonical] };
    }

    return { type:'unknown', key:canonical, raw:normalized, weight:0, scent:null };
  }

  function buildProfile(items, options) {
    options = options || {};

    var noteCounts = {};
    var accordCounts = {};
    var familyCounts = {};
    var traitCounts = {};
    var unknownCounts = {};
    var totals = emptyScores();
    var knownWeight = 0;
    var noteWeight = 0;
    var accordWeight = 0;

    (Array.isArray(items) ? items : []).forEach(function (item) {
      var quantity = Math.max(1, Number(item && item.quantity) || 1);
      var tags = item && Array.isArray(item.tags) ? item.tags : [];

      tags.forEach(function (rawTag) {
        var signal = getSignal(rawTag);

        if (!signal.key) return;

        if (signal.type === 'unknown') {
          addScore(unknownCounts, signal.key, quantity);
          return;
        }

        if (signal.type === 'context') return;

        var evidenceWeight = quantity * signal.weight;
        knownWeight += evidenceWeight;

        if (signal.type === 'note') {
          noteWeight += evidenceWeight;
          addScore(noteCounts, signal.key, quantity);
        }

        if (signal.type === 'accord') {
          accordWeight += evidenceWeight;
          addScore(accordCounts, signal.key, quantity);
        }

        (signal.scent.families || []).forEach(function (family) {
          addScore(familyCounts, family, evidenceWeight);
        });

        (signal.scent.traits || []).forEach(function (trait) {
          addScore(traitCounts, trait, evidenceWeight);
        });

        DIMENSIONS.forEach(function (dimension) {
          totals[dimension] += (Number(signal.scent[dimension]) || 0) * evidenceWeight;
        });
      });
    });

    var avg = emptyScores();
    DIMENSIONS.forEach(function (dimension) {
      avg[dimension] = knownWeight ? clamp(totals[dimension] / knownWeight, 0, 5) : 0;
    });

    var profile = profileData(avg);

    return {
      knownWeight: knownWeight,
      noteWeight: noteWeight,
      accordWeight: accordWeight,
      avg: avg,
      key: profile.key,
      name: profile.name,
      short: profile.short,
      noteCounts: noteCounts,
      accordCounts: accordCounts,
      unknownCounts: unknownCounts,
      topNotes: topKeys(noteCounts, options.topNotes || 6),
      topAccords: topKeys(accordCounts, options.topAccords || 6),
      topFamilies: topKeys(familyCounts, options.topFamilies || 5),
      topTraits: topKeys(traitCounts, options.topTraits || 7)
    };
  }


  var DIMENSION_SUPPORT = {
    sweetness: [
      'sweet','vanilla','caramel','honey','marshmallow','chocolate','cacao',
      'cotton candy','cherry','peach','pear','plum','berry','apricot','fruity'
    ],
    freshness: [
      'fresh','citrus','bergamot','aquatic','marine','ozonic','green',
      'aromatic','tea','herbal','salty','mineral','apricot','neroli'
    ],
    warmth: [
      'warm','amber','spicy','vanilla','tonka','benzoin','tobacco','saffron',
      'resinous','balsamic','cinnamon','cardamom','boozy','rum','whiskey','chestnut','ambroxan'
    ],
    gourmand: [
      'gourmand','vanilla','caramel','honey','marshmallow','chocolate','cacao',
      'coffee','milk','lactonic','almond','pistachio','nutty','cotton candy',
      'rice','savory','chestnut'
    ],
    floral: [
      'floral','rose','jasmine','iris','orris','violet','tuberose','neroli','orange blossom','heliotrope'
    ],
    clean: [
      'clean','soapy','musk','aldehydic','aquatic','marine','ozonic','ambroxan','neroli'
    ],
    woody: [
      'woody','sandalwood','oud','patchouli','leather','suede','earthy','mossy'
    ]
  };

  function explicitDimensionSupport(tags) {
    var canonical = (Array.isArray(tags) ? tags : []).map(function (tag) {
      return canonicalTag(tag);
    });

    var support = {};

    DIMENSIONS.forEach(function (dimension) {
      var allowed = DIMENSION_SUPPORT[dimension] || [];
      support[dimension] = canonical.some(function (tag) {
        return allowed.indexOf(tag) !== -1;
      });
    });

    return support;
  }

  function applyProductPeakPreservation(profile, tags) {
    if (!profile || !profile.avg) return profile;

    var notePeaks = emptyScores();
    var accordPeaks = emptyScores();

    (Array.isArray(tags) ? tags : []).forEach(function (rawTag) {
      var signal = getSignal(rawTag);
      if (!signal || !signal.scent) return;

      DIMENSIONS.forEach(function (dimension) {
        var value = Number(signal.scent[dimension]) || 0;

        if (signal.type === 'note') {
          notePeaks[dimension] = Math.max(notePeaks[dimension], value);
        } else if (signal.type === 'accord') {
          accordPeaks[dimension] = Math.max(accordPeaks[dimension], value);
        }
      });
    });

    var adjusted = [];

    DIMENSIONS.forEach(function (dimension) {
      var notePeak = notePeaks[dimension];
      var current = Number(profile.avg[dimension]) || 0;

      // "Clean" is an overall impression rather than a note-family identity,
      // so it should not receive peak preservation from individual notes.
      if (dimension === 'clean') return;

      // Only intervene when a strong specific note has been diluted all the
      // way into the Low band. This keeps balanced products from being
      // artificially pushed upward in several dimensions at once.
      if (notePeak < 4 || current >= 1.5) return;

      // A matching broad accord confirms that this is a genuine product
      // characteristic. The correction is intentionally capped and can
      // never lift a Low dimension beyond the Soft band.
      var corroborated = accordPeaks[dimension] >= 4;
      var maxLift = corroborated ? 1.25 : 0.75;
      var target = clamp(current + maxLift, 0, 2.49);

      if (target > current) {
        adjusted.push({
          dimension: dimension,
          before: current,
          after: target,
          notePeak: notePeak,
          corroborated: corroborated,
          maxLift: maxLift
        });

        profile.avg[dimension] = target;
      }
    });

    // Re-evaluate the descriptive profile after product-only adjustments.
    var updatedProfile = profileData(profile.avg);
    profile.key = updatedProfile.key;
    profile.name = updatedProfile.name;
    profile.short = updatedProfile.short;
    profile.peakAdjustedDimensions = adjusted;

    return profile;
  }

  function buildProductProfile(productOrTags) {
    var tags = Array.isArray(productOrTags)
      ? productOrTags
      : (productOrTags && Array.isArray(productOrTags.tags) ? productOrTags.tags : []);

    var profile = buildProfile([{ quantity:1, tags:tags }], {
      topNotes:5,
      topAccords:5,
      topFamilies:4,
      topTraits:5
    });

    profile = applyProductPeakPreservation(profile, tags);
    profile.explicitDimensionSupport = explicitDimensionSupport(tags);

    return profile;
  }

  function normalizeQuizProfile(payload) {
    payload = payload || {};
    var source = payload.scores && typeof payload.scores === 'object' ? payload.scores : {};
    var avg = emptyScores();

    DIMENSIONS.forEach(function (dimension) {
      avg[dimension] = clamp(Number(source[dimension]) || 0, 0, 5);
    });

    return {
      source:'quiz',
      avg:avg,
      key:payload.profileKey || '',
      name:payload.name || payload.profileName || '',
      topNotes:Array.isArray(payload.topNotes) ? payload.topNotes.map(canonicalTag) : []
    };
  }


  function dominantDimensions(profile) {
    if (!profile || !profile.avg) return [];

    var ranked = DIMENSIONS.map(function (dimension) {
      return {
        dimension: dimension,
        value: Number(profile.avg[dimension]) || 0
      };
    }).sort(function (a, b) {
      return b.value - a.value;
    });

    var dominant = ranked.filter(function (item) {
      return item.value >= 3.5;
    });

    // Softer profiles may have no Strong/Signature traits. In that case,
    // use the two clearest Moderate+ directions so recommendations still
    // preserve the shape of the profile instead of matching on weak noise.
    if (!dominant.length) {
      dominant = ranked.filter(function (item) {
        return item.value >= 2.5;
      }).slice(0, 2);
    }

    // Absolute fallback: keep the single strongest dimension if the profile
    // contains any meaningful signal at all.
    if (!dominant.length && ranked.length && ranked[0].value > 0) {
      dominant = ranked.slice(0, 1);
    }

    return dominant;
  }

  function classifyRecommendation(sourceProfile, productProfile) {
    var comparison = compareProfiles(sourceProfile, productProfile);

    if (!comparison || !sourceProfile || !sourceProfile.avg || !productProfile || !productProfile.avg) {
      return {
        bucket:'outside',
        percent:0,
        comparison:comparison || null,
        dominant:[],
        alignedDominant:[],
        missedDominant:[]
      };
    }

    var dominant = dominantDimensions(sourceProfile);
    var alignedDominant = [];
    var missedDominant = [];

    dominant.forEach(function (item) {
      var sourceValue = Number(item.value) || 0;
      var productValue = Number(productProfile.avg[item.dimension]) || 0;

      // Dominant alignment is presence-based, not near-equality-based.
      // A Signature quiz/profile trait should still count as preserved when
      // the product expresses that dimension clearly at Soft/Moderate levels.
      // This prevents Signature source scores from eliminating otherwise
      // sensible Safe candidates across a real catalog.
      var minimumProductValue = sourceValue >= 4.25 ? 1.75 : 1.5;
      var aligned = productValue >= minimumProductValue;

      if (aligned) {
        alignedDominant.push(item.dimension);
      } else {
        missedDominant.push(item.dimension);
      }
    });

    var dominantCount = dominant.length;
    var alignedCount = alignedDominant.length;
    var requiredAdjacent = dominantCount;

    var productRankedDimensions = DIMENSIONS.map(function (dimension) {
      return {
        dimension:dimension,
        value:Number(productProfile.avg[dimension]) || 0
      };
    }).sort(function (a, b) {
      return b.value - a.value;
    });

    var topThreeDimensions = productRankedDimensions.slice(0, 3).map(function (item) {
      return item.dimension;
    });

    var topTwoDimensions = productRankedDimensions.slice(0, 2).map(function (item) {
      return item.dimension;
    });

    var dominantNames = dominant.map(function (item) {
      return item.dimension;
    });

    var dominantInTopThree = dominantNames.filter(function (dimension) {
      return topThreeDimensions.indexOf(dimension) !== -1;
    });

    var dominantInTopTwo = dominantNames.filter(function (dimension) {
      return topTwoDimensions.indexOf(dimension) !== -1;
    });

    var requiredTopThree = dominantCount ? Math.min(dominantCount, 2) : 0;

    var leadingCharacterCompatible =
      dominantCount === 0 ||
      (
        dominantInTopThree.length >= requiredTopThree &&
        dominantInTopTwo.length >= 1
      );

    var explicitSupport = productProfile.explicitDimensionSupport || {};
    var explicitlySupportsAllDominant = dominantNames.every(function (dimension) {
      return explicitSupport[dimension] === true;
    });

    // Safe recommendations should not introduce a major character that the
    // source profile explicitly shows as Low. Example: a Clean/Fresh profile
    // should not call a strongly Woody, Sweet, Floral, Warm, or Gourmand
    // product "Safe" merely because Fresh/Clean are also present.
    var lowDimensionDepartures = [];

    DIMENSIONS.forEach(function (dimension) {
      var sourceValue = Number(sourceProfile.avg[dimension]) || 0;
      var productValue = Number(productProfile.avg[dimension]) || 0;

      if (sourceValue < 1.5 && productValue >= 2.5) {
        lowDimensionDepartures.push({
          dimension:dimension,
          source:sourceValue,
          product:productValue
        });
      }
    });

    var safeCharacterCompatible = lowDimensionDepartures.length === 0;

    var adjacentStrongDepartures = [];

    DIMENSIONS.forEach(function (dimension) {
      var sourceValue = Number(sourceProfile.avg[dimension]) || 0;
      var productValue = Number(productProfile.avg[dimension]) || 0;

      if (sourceValue < 1.5 && productValue >= 3.5) {
        adjacentStrongDepartures.push({
          dimension:dimension,
          source:sourceValue,
          product:productValue
        });
      }
    });

    var adjacentCharacterCompatible = adjacentStrongDepartures.length === 0;

    // Meaningful overlap keeps Stretch from becoming a random "low score" bin.
    var meaningfulOverlap = DIMENSIONS.some(function (dimension) {
      var sourceValue = Number(sourceProfile.avg[dimension]) || 0;
      var productValue = Number(productProfile.avg[dimension]) || 0;

      return sourceValue >= 2.5 && productValue >= 1.5;
    });

    var bucket = 'outside';

    if (
      comparison.percent >= 78 &&
      (dominantCount === 0 || alignedCount === dominantCount) &&
      safeCharacterCompatible &&
      leadingCharacterCompatible &&
      explicitlySupportsAllDominant
    ) {
      bucket = 'safe';
    } else if (
      comparison.percent >= 60 &&
      (dominantCount === 0 || alignedCount >= requiredAdjacent) &&
      adjacentCharacterCompatible
    ) {
      bucket = 'adjacent';
    } else if (
      comparison.percent >= 45 &&
      meaningfulOverlap
    ) {
      bucket = 'stretch';
    }

    return {
      bucket:bucket,
      percent:comparison.percent,
      comparison:comparison,
      dominant:dominant.map(function (item) { return item.dimension; }),
      alignedDominant:alignedDominant,
      missedDominant:missedDominant,
      meaningfulOverlap:meaningfulOverlap,
      lowDimensionDepartures:lowDimensionDepartures,
      safeCharacterCompatible:safeCharacterCompatible,
      topThreeDimensions:topThreeDimensions,
      topTwoDimensions:topTwoDimensions,
      dominantInTopThree:dominantInTopThree,
      dominantInTopTwo:dominantInTopTwo,
      leadingCharacterCompatible:leadingCharacterCompatible,
      explicitlySupportsAllDominant:explicitlySupportsAllDominant,
      adjacentStrongDepartures:adjacentStrongDepartures,
      adjacentCharacterCompatible:adjacentCharacterCompatible
    };
  }

  function recommendationTargetPercent(groupKey) {
    if (groupKey === 'safe') return 86;
    if (groupKey === 'adjacent') return 69;
    if (groupKey === 'stretch') return 52;
    return 0;
  }

  function recommendationFallbackTier(groupKey, classification) {
    if (!classification) return 99;

    var dominantCount = (classification.dominant || []).length;
    var alignedCount = (classification.alignedDominant || []).length;
    var percent = Number(classification.percent) || 0;

    if (classification.bucket === groupKey) return 0;

    if (groupKey === 'safe') {
      var preservesAllDominant = dominantCount === 0 || alignedCount === dominantCount;
      var characterCompatible = classification.safeCharacterCompatible !== false;
      var leadingCompatible = classification.leadingCharacterCompatible !== false;
      var semanticSupport = classification.explicitlySupportsAllDominant !== false;

      // Safe may relax percentage to complete the row, but it must preserve
      // every dominant dimension AND avoid introducing a Moderate+ dimension
      // that the source profile explicitly marks Low.
      if (preservesAllDominant && characterCompatible && leadingCompatible && semanticSupport && percent >= 72) return 1;
      if (preservesAllDominant && characterCompatible && leadingCompatible && semanticSupport && percent >= 60) return 2;
      if (preservesAllDominant && characterCompatible && leadingCompatible && semanticSupport && percent >= 45) return 3;

      return 99;
    }

    if (groupKey === 'adjacent') {
      var preservesAllDominant = dominantCount === 0 || alignedCount === dominantCount;
      var characterCompatible = classification.adjacentCharacterCompatible !== false;

      // Adjacent remains rooted in the same dominant profile.
      // Percentage may relax, but dominant-trait preservation and the
      // Strong+ contradiction guard never relax.
      if (preservesAllDominant && characterCompatible && percent >= 52) return 1;
      if (preservesAllDominant && characterCompatible && percent >= 40) return 2;
      if (preservesAllDominant && characterCompatible) return 3;

      return 99;
    }

    if (groupKey === 'stretch') {
      // Stretch can be farther away, but it must retain meaningful overlap.
      if (classification.meaningfulOverlap && percent >= 40) return 1;
      if (classification.meaningfulOverlap && percent >= 25) return 2;
      if (classification.meaningfulOverlap) return 3;

      return 99;
    }

    return 99;
  }

  function rankRecommendations(sourceProfile, products, groupKey, usedIds, limit) {
    var maxItems = Math.max(1, Number(limit) || 6);
    var target = recommendationTargetPercent(groupKey);

    return (Array.isArray(products) ? products : [])
      .map(function (product) {
        if (!product || (usedIds && usedIds[product.id])) return null;

        var productProfile = buildProductProfile(product.tags || []);
        if (!productProfile || !productProfile.knownWeight) return null;

        var classification = classifyRecommendation(sourceProfile, productProfile);
        if (!classification || !classification.comparison) return null;

        return {
          product:product,
          productProfile:productProfile,
          comparison:classification.comparison,
          classification:classification,
          bucket:classification.bucket,
          fallbackTier:recommendationFallbackTier(groupKey, classification)
        };
      })
      .filter(function (item) {
        return item && item.fallbackTier < 99;
      })
      .sort(function (a, b) {
        if (a.fallbackTier !== b.fallbackTier) {
          return a.fallbackTier - b.fallbackTier;
        }

        var aDist = Math.abs((Number(a.classification.percent) || 0) - target);
        var bDist = Math.abs((Number(b.classification.percent) || 0) - target);

        if (aDist !== bDist) return aDist - bDist;

        return String(a.product.title || '').localeCompare(String(b.product.title || ''));
      })
      .slice(0, maxItems);
  }

  function compareProfiles(customerProfile, productProfile) {
    if (!customerProfile || !customerProfile.avg || !productProfile || !productProfile.avg) {
      return { score:0, percent:0, label:'Not enough data', key:'unknown', strongestOverlap:[] };
    }

    var totalDistance = 0;
    var overlaps = [];

    DIMENSIONS.forEach(function (dimension) {
      var customerValue = Number(customerProfile.avg[dimension]) || 0;
      var productValue = Number(productProfile.avg[dimension]) || 0;
      var distance = Math.abs(customerValue - productValue);

      totalDistance += distance;

      overlaps.push({
        dimension:dimension,
        label:dimensionMeta[dimension] && dimensionMeta[dimension].label
          ? dimensionMeta[dimension].label
          : titleCase(dimension),
        customer:customerValue,
        product:productValue,
        strength:Math.min(customerValue, productValue) - distance * 0.35
      });
    });

    var similarity = clamp(1 - totalDistance / (DIMENSIONS.length * 5), 0, 1);
    var percent = Math.round(similarity * 100);

    var label;
    var key;

    if (percent >= 82) {
      label = 'Strong Match';
      key = 'strong';
    } else if (percent >= 66) {
      label = 'Good Match';
      key = 'good';
    } else if (percent >= 48) {
      label = 'Worth Exploring';
      key = 'explore';
    } else {
      label = 'Something Different';
      key = 'different';
    }

    overlaps.sort(function (a, b) {
      return b.strength - a.strength;
    });

    return {
      score: similarity,
      percent: percent,
      label: label,
      key: key,
      strongestOverlap: overlaps.slice(0, 3),
      dimensions: overlaps
    };
  }

  window.NBBScentEngine = {
    version:'3.0.3',
    dimensions:DIMENSIONS.slice(),
    weights:{ note:NOTE_WEIGHT, accord:ACCORD_WEIGHT, context:0 },
    noteMap:noteMap,
    accordMap:accordMap,
    aliases:aliases,
    contextTags:contextTags,
    dimensionMeta:dimensionMeta,
    normalizeTag:normalizeTag,
    canonicalTag:canonicalTag,
    titleCase:titleCase,
    levelData:levelData,
    profileData:profileData,
    getSignal:getSignal,
    buildProfile:buildProfile,
    applyProductPeakPreservation:applyProductPeakPreservation,
    explicitDimensionSupport:explicitDimensionSupport,
    buildProductProfile:buildProductProfile,
    normalizeQuizProfile:normalizeQuizProfile,
    dominantDimensions:dominantDimensions,
    compareProfiles:compareProfiles,
    classifyRecommendation:classifyRecommendation,
    rankRecommendations:rankRecommendations
  };

  window.dispatchEvent(new CustomEvent('nbb:scent-engine-ready', {
    detail:{ version:window.NBBScentEngine.version }
  }));
})();
